import React, { Component } from "react";
import InputMask from "react-input-mask";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../../_Content/css/modal.css";

class ModalConfirmacao extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        modalVisivel: false,
        mensagemAlerta: this.props.mensagemAlerta
      };
    }
  
    alterarVisibilidadeModal = () => {
      this.setState({
        modalVisivel: !this.state.modalVisivel
      });
    };

    botaoClicked = (btnSim) => {
      if(btnSim){
        this.props.action();
      }
      this.alterarVisibilidadeModal();
    }
  
    render() {
        return (
          <div>
            <Modal
              id="modal-confirmacao"
              isOpen={this.state.modalVisivel}
              toggle={this.state.toggle}
              size="bd-example-modal-sm"
              className={this.props.className}>
              <ModalBody>
                <img src="/img/ecoicos/ecoico-nao-realizada.svg" alt="alerta" />
                <label>Cuidado!</label>
                <span className="span1">
                  {this.state.mensagemAlerta}
                </span>
                {/*<span className="span2">Aguarde e tente novamente.</span>*/}

                <div className="optsBox clearfix">
                  <Button className="ecobtn fat vazado baby-blue float-left" onClick={() => this.botaoClicked(true)}>
                    Sim
                  </Button>
                  <Button className="ecobtn fat vazado vermelho float-right" onClick={() => this.botaoClicked(false)}>
                    Não
                  </Button>
                </div>
              </ModalBody>
            </Modal>
          </div>
        );
    }
  }
  
  export default ModalConfirmacao;
  


// WEBPACK FOOTER //
// ./src/Componente/Modulo/ModalConfirmacao.jsx